export default __webpack_public_path__ + "static/media/uicons-regular-rounded.fa5388e0.eot";